<div class="row" *ngIf="isAddLanes">
    <div class="col-sm-5">
        <div class="row">
            <div class="col-sm-4">
                <h4>Origin Markets</h4>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Country</label>
                        <select name="originCountryID" [(ngModel)]="originCountryID" (change)="countryChanged($event, 'origin')" class="form-select">
                            <option value="0">- Select Country -</option>
                            <option *ngFor="let country of countryList" value="{{country.countryId}}">{{country.abbrev}} - {{country.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">State</label>
                        <select name="originStateID" [(ngModel)]="originStateID" (change)="stateChanged($event, 'origin')" class="form-select" [disabled]="originCountryID==0">
                            <option value="0">- Select State -</option>
                            <option *ngFor="let state of originStateList" value="{{state.stateId}}">{{state.abbrev}} - {{state.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">City</label>
                        <city-state-zip-dropdown [parentForm]="formGroup"
                                                 [ctrlName]="'originCityCtrl'"
                                                 [placeholder]="'Enter a City'"
                                                 [isChooseDefaultZip]="true"
                                                 (citySelected)="citySTChanged($event, 'originCityCtrl')"
                                                 [cityID]="originCityID"></city-state-zip-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Markets</label>
                        <select name="originMarkets" [(ngModel)]="originMarketIDList" (change)="marketChanged($event, 'origin')" class="form-select" [ngClass]="(originMarketIDList.length==0) ? 'border border-danger' : ''" size="5" multiple>
                            <option *ngFor="let market of originMarketList" value="{{market.marketID}}">{{market.marketName}} - {{market.marketCity}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <h4>Destination Markets</h4>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Country</label>
                        <select name="destinationCountryID" [(ngModel)]="destinationCountryID" (change)="countryChanged($event, 'destination')" class="form-select">
                            <option value="0">- Select Country -</option>
                            <option *ngFor="let country of countryList" value="{{country.countryId}}">{{country.abbrev}} - {{country.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">State</label>
                        <select name="destinationStateID" [(ngModel)]="destinationStateID" (change)="stateChanged($event, 'destination')" class="form-select" [disabled]="destinationCountryID==0">
                            <option value="0">- Select State -</option>
                            <option *ngFor="let state of destinationStateList" value="{{state.stateId}}">{{state.abbrev}} - {{state.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">City</label>
                        <city-state-zip-dropdown [parentForm]="formGroup"
                                                 [ctrlName]="'destinationCityCtrl'"
                                                 [placeholder]="'Enter a City'"
                                                 [isChooseDefaultZip]="true"
                                                 (citySelected)="citySTChanged($event, 'destinationCityCtrl')"
                                                 [cityID]="destinationCityID"></city-state-zip-dropdown>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Markets</label>
                        <select name="destinationMarkets" [(ngModel)]="destinationMarketIDList" (change)="marketChanged($event, 'destination')" class="form-select" [ngClass]="(destinationMarketIDList.length==0) ? 'border border-danger' : ''" size="5" multiple>
                            <option *ngFor="let market of destinationMarketList" value="{{market.marketID}}">{{market.marketName}} - {{market.marketCity}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Mode</label>
                        <select name="modeID" [(ngModel)]="modeID" (change)="modeChanged($event)" class="form-select" [ngClass]="(modeID==0) ? 'border border-danger' : ''" size="5" required>
                            <option *ngFor="let mode of modeList" value="{{mode.modeID}}">{{mode.abbrev}} - {{mode.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Equipment Class</label>
                        <select name="equipmentClassID" [(ngModel)]="equipmentClassID" (change)="equipmentClassChanged($event)" class="form-select" [ngClass]="(equipmentClassID==0) ? 'border border-danger' : ''" size="5" required>
                            <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">[{{item.abbreviation}}] {{item.className}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="font-weight-bold">Trailer</label>
                        <select name="trailerTypeID" [(ngModel)]="trailerTypeID" (change)="trailerTypeChanged($event)" class="form-select" [ngClass]="(trailerTypeID==0) ? 'border border-danger' : ''" size="5" required>
                            <option *ngFor="let trailerType of trailerTypeList" value="{{trailerType.trailerTypeID}}">{{trailerType.abbrev}} - {{trailerType.description}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-7">
        <div class="row m-2">
            <div class="col-sm-4">
                <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                       id="isRoundTrip"
                       name="isRoundTrip"
                       [(ngModel)]="isRoundTrip"
                       [checked]="isRoundTrip"
                       (change)="setCarrierLanes()"
                       autocomplete="off" />
                <label for="isRoundTrip" class="font-weight-bold">Round Trip</label>
            </div>
            <div class="col-sm-4">
                <label class="font-weight-bold">Rate/mi</label>
                <input type="number" [(ngModel)]="ratePerMile" (change)="setCarrierLanes()" class="form-control" required />
            </div>
            <div class="col-sm-4 text-end">
                <button type="button" class="btn btn-primary m-1" (click)="saveAddLanes()">Add Lanes</button>
                <button type="button" class="btn btn-secondary m-1" (click)="cancelAddLanes()">Reset Form</button>
            </div>
        </div>
        <kendo-expansionpanel [title]="'Add Lanes'"
                              [subtitle]="'Total: ' + addLanesList.length"
                              [expanded]="true">
            <kendo-grid #addLanesGrid
                        [data]="addLanesGridData"
                        [pageSize]="addLanesGridState.take"
                        [skip]="addLanesGridState.skip"
                        [sort]="addLanesGridState.sort"
                        [filter]="addLanesGridState.filter"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        [rowClass]="addLaneRowCallback"
                        (dataStateChange)="addLanesDataStateChange($event)">
                <kendo-grid-column field="preferred" title="Preferred">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                               id="preferred{{ dataItem.preferred }}"
                               name="preferred{{ dataItem.preferred }}"
                               (change)="dataItem.preferred=!dataItem.preferred"
                               [checked]="dataItem.preferred"
                               autocomplete="off" />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="ratePerMile" title="$/mi" format="{0:c}"></kendo-grid-column>
                <kendo-grid-column field="oZip3" title="OZip3"></kendo-grid-column>
                <kendo-grid-column field="dZip3" title="DZip3"></kendo-grid-column>
                <kendo-grid-column field="oMktDesc" title="Origin Mkt"></kendo-grid-column>
                <kendo-grid-column field="dMktDesc" title="Destination Mkt"></kendo-grid-column>
                <kendo-grid-column field="modeAbbrev" title="Mode"></kendo-grid-column>
                <kendo-grid-column field="trailerTypeAbbrev" title="Trailer"></kendo-grid-column>
                <kendo-grid-column field="roundTrip" title="RT">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                               id="roundTrip"
                               name="roundTrip"
                               [checked]="dataItem.roundTrip"
                               [disabled]="true"
                               autocomplete="off" />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="rateIndexDescription" title="Rate Idx"></kendo-grid-column>
                <!--<kendo-grid-column field="isPreferred" title="Preferred">
        <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                   id="isPreferred{{ dataItem.isPreferred }}"
                   name="isPreferred{{ dataItem.isPreferred }}"
                   (change)="dataItem.isPreferred=!dataItem.isPreferred"
                   [checked]="dataItem.isPreferred"
                   autocomplete="off" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="ratePerMile" title="$/mi" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column field="oZip3" title="OZip3"></kendo-grid-column>
    <kendo-grid-column field="dZip3" title="DZip3"></kendo-grid-column>
    <kendo-grid-column field="originMarket" title="Origin Mkt"></kendo-grid-column>
    <kendo-grid-column field="destinationMarket" title="Destination Mkt"></kendo-grid-column>
    <kendo-grid-column field="modeAbbrev" title="Mode"></kendo-grid-column>
    <kendo-grid-column field="trailerTypeAbbrev" title="Trailer"></kendo-grid-column>
    <kendo-grid-column field="minRate" title="RT">
        <ng-template kendoGridCellTemplate let-dataItem>
            <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                   id="isRoundTrip"
                   name="isRoundTrip"
                   [checked]="dataItem.isRoundTrip"
                   [disabled]="true"
                   autocomplete="off" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="rateIndexName" title="Rate Idx"></kendo-grid-column>-->
            </kendo-grid>
            <label class="text-danger font-weight-bold" *ngIf="isLaneExists">Red row text: Carrier Lane already exists. Please edit in the existing lanes below.</label>
        </kendo-expansionpanel>
    </div>
</div>
<div class="row">
    <div [ngClass]="isEdit ? 'col-sm-6' : 'col-sm-11'">
        <kendo-expansionpanel [title]="'Carrier Lanes'"
                              [subtitle]="'Total: ' + filteredLanes.length"
                              [expanded]="true">
            <kendo-grid #lanesGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        (dataStateChange)="dataStateChange($event)">
                <kendo-grid-column title="Action">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.carrierLaneID)"><i class="fas fa-pencil-alt"></i></button>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="preferred" title="Preferred">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                               id="preferred"
                               name="preferred"
                               [checked]="dataItem.preferred"
                               [disabled]="true"
                               autocomplete="off" />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="trailerTypeAbbrev" title="Trailer"></kendo-grid-column>
                <kendo-grid-column field="procurements" title="Cnt"></kendo-grid-column>
                <kendo-grid-column field="minRate" title="Min Rate">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.minRate > 0 ? (dataItem.minRate | currency) : ''}}<br />
                        {{dataItem.minRate > 0 ? (dataItem.minRateDate | date:'shortDate') : ''}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="ratePerMile" title="Rate/mi">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.ratePerMile > 0 ? (dataItem.ratePerMile | currency) : ''}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="originDistributionCenter" title="Origin DC"></kendo-grid-column>
                <kendo-grid-column field="destinationDistributionCenter" title="Dest DC"></kendo-grid-column>
                <kendo-grid-column field="modeAbbrev" title="Mode"></kendo-grid-column>
                <kendo-grid-column field="lastRan" title="Last Ran">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.lastRan | date:'shortDate'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="notes" title="Notes"></kendo-grid-column>
            </kendo-grid>
        </kendo-expansionpanel>
    </div>
    <div class="col-sm-6" *ngIf="isEdit">
        <carrier-lane-form [carrierLaneID]="carrierLaneID" (onRefresh)="refreshGrid()"></carrier-lane-form>
    </div>
</div>
